export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
export const trimDate = (value: string | null | undefined): string => {
  if (!value) return '';
  return value.split('T')[0];
};